export const environment = {
	production: "true",
	api: {
		root: "https://centros-pre-api.acciona.com/api",
	},
	urlAdmin: "/admin",
	endpoint: {
		place: {
			get: "/place",
		},
		check: {
			checkBack: "/Health/Check",
			checkDatabase: "/Health/CheckDatabaseConnection",
		},
		settings: {
			fav: "/settings/fav",
			unfav: "/settings/fav",
			favPages: "/settings/favPage",
			favPage: "/settings/favPage",
			unfavPage: "/settings/unfavPage",
			user: "/settings/user",
			isAdmin: "/settings/isAdmin",
		},
		contratos: {
			getContratosList: "/Contratos/List",
			getContratoById: "/Contratos/ContratoById",
			getContratoImage: "/Contratos/GetContratoImage",
			createContrato: "/Contratos/Create",
			updateContrato: "/Contratos/Edit",
			uploadFinancialData: "/Contratos/UploadFinancialData",
			notificacionCese: "/Cebe/NotificarCese",
			notificacionAlta: "/Cebe/NotificarAlta",
			getContratosPadreList: "/Contratos/ListBase",
			asociarCebeContrato: "/Contratos/AsociarCebe",
		},
		cebeContratos: {
			getContratoByCebe: "/CebesContratos/GetContratoByCebe",
			updateContrato: "/CebesContratos/Edit",
		},
		cebePal: {
			getPalById: "/CebePal/GetPalById",
			getPalByCebe: "/CebePal/GetPalByCebe",
			getPalList: "/CebePal/List",
			updatePal: "/CebePal/Update",
			createPal: "/CebePal/Create",
		},
		centros: {
			list: "/Centros/List",
			getCentroById: "/Centros/GetById",
			getCentroByCebes: "/CebeOperativo",
			getCentroByContrato: "/Centros/GetByContratosId",
			updateCentro: "/Centros/UpdateCentro",
			createCentro: "/Centros/CreateCentro",
			uploadUsers: "/Centros/UploadUsers",
			getCentrosByContratoPadre: "/Centros/GetByContratoId",
			getContratoCentroByCentro: "/Centros/GetContratoCentro",
			exportToExcel: "/Centros/ExportToExcel",
			Validar: "/Centros/Validar",
			ListoMigrar: "/Centros/ListoMigrar",
		},
		admin: {
			getAdminById: "/Admin/GetById",
			updateAdmin: "/Admin/UpdateAdmin",
			exportToExcel: "/Admin/ExportToExcel",
		},
		useradmin: {
			getUserList: "/UserAdmin/GetList",
			getUserById: "/UserAdmin/Get",
			insertUser: "/UserAdmin/Insert",
			updateUser: "/UserAdmin/Update",
			deleteUser: "/UserAdmin/Delete",
		},
		master: {
			getEmpleadosList: "/Master/ListEmpleado",
			getActividadList: "/Master/ListActividad",
			getPaisList: "/Master/ListPais",
			getZonaList: "/Master/ListZonaBySociedad",
			getZonaListZonaBySociedadByResponsable:
				"/Master/ListZonaBySociedadByResponsable",
			getSociedadById: "/Master/GetSociedadById",
			getSociedadList: "/Master/ListSociedad",
			getConsolidacionFinancieraList:
				"/Master/ListConsolidacionFinanciera",
			getTipoProyectoList: "/Master/ListTipoProyecto",
			getAdquisicionReactivosList: "/Master/ListAdquisicionReactivos",
			getContratoElectricidadList: "/Master/ListContratoElectricidad",
			getPagoCombustibleList: "/Master/ListPagoCombustible",
			getPagoCombustibleVehiculosList:
				"/Master/ListPagoCombustibleVehiculos",
			getPagoElectricidadList: "/Master/ListPagoElectricidad",
			getTitularFangosList: "/Master/ListTitularFangos",
			getTitularidadEnergiaList: "/Master/ListTitularidadEnergia",
			getTitularResiduosDesbasteList:
				"/Master/ListTitularResiduosDesbaste",
			getTitularResiduosNoPeligrososList:
				"/Master/ListTitularResiduosNoPeligrosos",
			getTitularResiduosPeligrososList:
				"/Master/ListTitularResiduosPeligrosos",
			getUbicacionEspanaList: "/Master/ListUbicacionEspana",
			getTipoPagoElecOMList: "/Master/ListTipoPagoElecOM",
			getTipoInstalacionList: "/Master/ListTipoInstalacion",
			getCentroActividadList: "/Master/ListCentroActividad",
			getLocalizacionList: "/Master/ListLocalizacion",
			getDesnitrificacionList: "/Master/ListDesnitrificacion",
			getDigestionAnaerobiaFangoList:
				"/Master/ListDigestionAnaerobiaFango",
			getCebesCentrosList: "/Master/ListCebesCentros",
			getPrimaIncluidaList: "/Master/ListPrimaIncluida",
			getTipoAlcanceList: "/Master/ListTipoAlcance",
			getRecuperacionFosforoList: "/Master/ListRecuperacionFosforo",
			getUsuarioCentroProcedureList: "/Master/ListUsuarioCentroProcedure",
			getTipoRiesgoSocialList: "/Master/ListTipoRiesgoSocial",
			getListTipoUsoAgua: "/Master/ListTipoUsoAgua",
			getSuperCentroList: "/Master/ListSuperCentro",
		},
		tag: {
			get: "/tag",
		},
		area: {
			find: "/area",
			get: "/area",
		},
		department: {
			find: "/department",
			get: "/department",
			getByZone: "/department/byzone",
		},
		country: {
			get: "/country",
		},
		site: {
			getPublic: "/site/public",
			findPublic: "/site/public",
			get: "/site",
			find: "/site",
			getByServiceCode: "/site/site",
		},
	},
	azureAD: {
		// This is your client ID
		clientId: "8f3d9880-7d1a-4b2a-876e-7e050276ccb2",
		// The GUID is your Directory (or tenant) ID
		authority:
			"https://login.microsoftonline.com/f5fd9e16-114f-4820-8de1-6312daf9aebb",
		// This is your redirect URI
		redirectUri: "https://centros-pre.acciona.com/",
		postLogoutRedirectUri: "https://centros-pre.acciona.com/",
		navigateToLoginRequestUrl: true,
	},
};

// import "fontsource-roboto";
